// 通用方法
let kit = {
	formatting(type, value){
		if( type == 'money' ){
			const integer = value.split('.')[0];
			const decimal = value.split('.')[1];
			if(decimal){
				return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
			}
			return integer.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + '.00'
		}else if( type == 'score' ){
			const scoreValue = value.toString();
			if( scoreValue.split('.').length <= 1 ){
				return scoreValue + '.0';
			}
			return scoreValue
		}
	},
	scoreLable(score){
		const scoreValue = parseInt(score);
		switch(scoreValue){
			case 5 : return '十分推荐';break;
			case 4 : return '比较推荐';break;
			case 2 : return '推 荐';break;
			case 2 : return '一 般';break;
			case 1 : return '不推荐';break;
			default: return '推 荐';
		}
	},
	// 结算方式拼接
	salaryJoinType(salary, type){
		switch(type){
			case "日结" : return salary + '/天';break;
			case "月结" : return salary + '/月';break;
			case "小时工" : return salary + '/小时';break;
			case "计件" : return salary + '/件';break;
			default : return salary
		}
	},
}
export default kit
